import { render, staticRenderFns } from "./penerimaanAdd.vue?vue&type=template&id=1a9e5518&scoped=true"
import script from "./penerimaanAdd.vue?vue&type=script&lang=js"
export * from "./penerimaanAdd.vue?vue&type=script&lang=js"
import style0 from "./penerimaanAdd.vue?vue&type=style&index=0&id=1a9e5518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9e5518",
  null
  
)

export default component.exports